import { alpha, borderRadius, height, maxHeight, padding } from "@mui/system";

import { fonts, gutterX } from "../shared/ticketLayout";

const styles = (theme) => ({
	paperContainer: {
		borderRadius: "16px",
		padding: 3,
		display: "flex",
		flexDirection: "column",
		gap: 2,
		position: "relative",
		overflow: "hidden",
	},
	containerHeader: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
	},
	containerBodyAnswer: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
	},
	containerInfoClient: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		gap: 1,
	},
	containerAnswer: {
		width: "100%",
		display: "flex",
		gap: 2,
		display: "flex",
		flexDirection: "column",
		p: 1,
		borderRadius: "16px",
		margin: "10px 0",
		backgroundColor:
			theme.palette.mode === "dark"
				? theme.palette.colors.black.medium
				: theme.palette.colors.black.lighter,
	},
	boxAnswer: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexWrap: "wrap",
		gap: 1,
	},
	descriptionAvaliacao: {
		fontWeight: "bold",
		opacity: 0.5,
	},
	buttonCancel: {
		color: theme.palette.mode !== "dark" && theme.palette.colors.black.darker,
	},
	boxEdit: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		height: "50px",
		px: gutterX,
	},
	containerTitle: {
		display: "flex",
		flexDirection: "row",
		gap: 0.5,
		flex: 1,
		minWidth: 0,
		alignItems: "center",
	},
	title: {
		fontWeight: "bold",
		fontSize: "18px",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	},
	cardDescricao: {
		fontSize: fonts.body,
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontWeight: "bold",
	},
	chipBody: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 0.5,
	},
	nameDescription: {
		fontWeight: "bold",
		fontSize: fonts.label,
		display: "flex",
		alignItems: "center",
		gap: 0.5,
	},
	valueDescription: {
		fontSize: fonts.label,
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	},
	containerDataDescription: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
	},
	containerModal: {
		position: "absolute",
		borderRadius: "16px",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: " 90%",
		maxWidth: "1000px",
		bgcolor: "background.paper",
		boxShadow: 24,

		height: "600px",
	},
	containerIconExist: {
		position: "absolute",
		top: 0,
		right: 0,
		width: "50px",
		height: "50px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	conatinerLoading: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	chipStatus: {
		minWidth: "120px",
		color: theme.palette.white.main,
	},
	titleModal: {
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		width: "95%",
	},
	valueChip: {
		fontSize: fonts.chip,
		fontWeight: "bold",
	},
	containerHeaderModal: {
		borderRadius: "16px",
		display: "flex",
		flexDirection: "column",
		position: "sticky",
		top: 0,
		backgroundColor: alpha(theme.palette.background.paper, 0.8),
		px: gutterX,
		py: 2.5,
		gap: 1,
	},
	titleDescription: {
		fontSize: fonts.sectionTitle,
		fontWeight: "bold",
		marginBottom: "5px",
		marginTop: "15px",
		display: "flex",
		alignItems: "center",
		gap: 0.5,
	},
	boxBodyModal: { px: gutterX, py: 1.25 },
	containerBodyModal: { maxHeight: "65%", overflowY: "auto" },
	containerPaperModal: {
		width: "100%",
		borderRadius: "16px",
		padding: 2,
		overflowY: "auto",
		display: "flex",
		gap: 1,
		flexWrap: "wrap",
	},
	titleChipModal: {
		fontWeight: "bold",
		fontSize: fonts.chip,
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	},
	containerDescription: {
		width: "100%",
		minHeight: "60px",
	},
	clearIcon: {
		fontSize: "20px",
		color: theme.palette.text.main,
	},
	buttonDetails: {
		width: "80%",
		color: theme.palette.text.main,
		borderColor: theme.palette.text.main,
	},
	containerPaperMensagem: {
		width: "100%",
		borderRadius: "16px",
		backgroundColor:
			theme.palette.mode === "dark"
				? theme.palette.colors.black.medium
				: theme.palette.colors.black.lighter,
	},
	bodyMensagem: { padding: 2, display: "flex", gap: 2 },
	boxImg: {
		width: "50px",
		height: "50px",
		objectFit: "cover",
		display: "block",
		borderRadius: "8px",
		overflow: "hidden",
		flexShrink: 0,
		flexGrow: 0,
		maxWidth: "50px",
		maxHeight: "50px",
	},
	chipSelect: {
		backgroundColor: alpha(theme.palette.primary.main, 0.5),
		fontWeight: "bold",
	},
	containermensagem: {
		display: "flex",
		alignItems: "center",
		width: "100%",
	},
	boxAnexo: {
		width: 100,
		height: 100,
		objectFit: "cover",
		display: "block",
		borderRadius: "8px",
		overflow: "hidden",
		flexShrink: 0,
		flexGrow: 0,
		cursor: "pointer",
	},
	boxTextAnexo: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "block",
	},
	chipTypeAtendimento: {
		width: "180px",
		backgroundColor: theme.palette.colors.pink.medium,
		color: theme.palette.white.main,
	},
	containerTabs: {
		width: "100%",
		bgcolor: "background.paper",
		padding: "0 2%",
	},
	buttonAnexo: {
		width: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "inline-flex",
		justifyContent: "flex-start",
	},
	boxWithoutImg: {
		width: 50,
		height: 50,

		display: "block",
		borderRadius: "8px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor:
			theme.palette.mode === "dark"
				? theme.palette.colors.black.medium
				: theme.palette.colors.black.lighter,
	},
	chip: {
		backgroundColor: theme.palette.cardTrafficData.paperColor.statusUp,
		fontWeight: "bold",
		color: theme.palette.white.main,
		marginLeft: 1,
		flexShrink: 0,
	},
	titleProtocolo: {
		fontSize: fonts.label,
		fontWeight: "bold",
	},
	boxDescription: {
		display: "flex",
		gap: 1,
	},
	description: {
		fontSize: fonts.body,
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "-webkit-box",
		WebkitLineClamp: 3,
		WebkitBoxOrient: "vertical",
		fontWeight: "regular",
		color:
			theme.palette.mode === "dark"
				? theme.palette.colors.black.light
				: theme.palette.colors.black.medium,
	},
	containerInfo: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		gap: 1,
		justifyItems: "center",
	},

	icon: {
		fontSize: "20px",
	},
	boxIcon: {
		position: "absolute",
		top: 0,
		right: 0,
		minWidth: "40px",
		height: "20px",
		padding: 1,
		borderTopRightRadius: "16px",
		borderBottomLeftRadius: "16px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 0.5,
	},
	boxFluxo: {
		position: "absolute",
		top: 0,
		left: 0,
		minWidth: "40px",
		height: "20px",
		padding: 1,
		borderTopLeftRadius: "16px",
		borderBottomRightRadius: "16px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 0.5,
	},
	iconStatus: { fontSize: fonts.body },
	titleStatusCard: {
		fontSize: "9px",
		fontWeight: 900,
		color: theme.palette.white.main,
	},
	containerButton: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginTop: "10px",
	},
	boxInfos: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	containerStatusModal: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 0.5,
	},
});

export default styles;
